<template>
	<div class="pages-upload">
		<div class="upload-wrapper">
			<div class="back">
				<img :src="
						require(`../assets/pc-change-images/backList-btn-${this.$i18n.locale}.png`)
					" alt="#" @click="goPageList" />
			</div>
			<div class="close" @click="goPageList()">X</div>
			<div class="title-img">
				<img :src="
						require(`../assets/pc-change-images/upload-logo-${this.$i18n.locale}.png`)
					" alt="#" />
			</div>
			<el-row>
				<el-col :xs="24" :sm="12" :md="12" :lg="16" :xl="16">
					<div class="upload-file-wrapper" @click="uploadFile()">
						<div class="upload-left">
							<img src="../assets/upload/snowflake-lt.png" alt="#" class="left-top" />
							<img src="../assets/upload/snowflake-rb.png" alt="#" class="right-bottom" />
							<div class="upload-img">
								<div v-if="!work.file"></div>
								<img v-else :src="fileUrl(work.file)" alt />
							</div>
							<div v-if="!work.file" class="label">
								<span class="upload-label">+ {{ $t('uploadWork.uploadInfo') }}</span>
								<span class="upload-msg">{{ $t('uploadWork.uploadMsg') }}</span>
							</div>
						</div>
						<input ref="filePicker" type="file" class="hidden" accept="image/jpeg" @change="onFilePicked($event)" />
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<div class="work-form">
						<el-row>
							<el-col :xs="8" :sm="5" :md="24" :lg="24" :xl="24">
								<div class="filed-label">{{ $t('uploadWork.workName') }}</div>
							</el-col>
							<el-col :xs="16" :sm="19" :md="24" :lg="24" :xl="24">
								<div class="filed-input">
									<el-input size="mini" v-model="work.title" placeholder></el-input>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="8" :sm="5" :md="24" :lg="24" :xl="24">
								<div class="filed-label">{{ $t('uploadWork.creator') }}</div>
							</el-col>
							<el-col :xs="16" :sm="19" :md="24" :lg="24" :xl="24">
								<div class="filed-input">
									<el-input size="mini" v-model="work.name" placeholder></el-input>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="8" :sm="5" :md="24" :lg="24" :xl="24">
								<div class="filed-label">{{ $t('uploadWork.age') }}</div>
							</el-col>
							<el-col :xs="16" :sm="19" :md="24" :lg="24" :xl="24">
								<div class="filed-input">
									<el-input size="mini" v-model.number="work.age" type="number" placeholder></el-input>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="8" :sm="5" :md="24" :lg="24" :xl="24">
								<div class="filed-label">{{ $t('uploadWork.nationality') }}</div>
							</el-col>
							<el-col :xs="16" :sm="19" :md="24" :lg="24" :xl="24">
								<div class="filed-input">
									<el-input size="mini" v-model="work.from" placeholder></el-input>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="8" :sm="5" :md="24" :lg="24" :xl="24">
								<div class="filed-label"></div>
							</el-col>
							<el-col :xs="16" :sm="19" :md="24" :lg="24" :xl="24">
								<div class="filed-input">
									<div class="msg">({{ $t('uploadWork.inputMsg') }})</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</el-col>
			</el-row>
			<div class="save-btn">
				<img :src="
						require(`../assets/pc-change-images/upload-submitBtn-${this.$i18n.locale}.png`)
					" alt="#" @click="save()" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PagesUpload',
	data() {
		return {
			saving: false,
			work: {
				title: null,
				name: null,
				age: null,
				from: null,
				file: null
			},
			fileResult: null
		}
	},
	methods: {
		goPageList() {
			this.$router.push({ name: 'PagesWorks' })
		},
		validate() {
			if (!this.work.file) {
				return '请添加图片'
			}
			if (!this.work.title) {
				return '请填写基本信息'
			} else {
				const reg = new RegExp(
					"[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
				)
				if (reg.test(this.work.title)) {
					return '作品名称不支持输入特殊符号'
				}
			}
			if (!this.work.name) {
				return '请填写基本信息'
			} else {
				if (this.$i18n.locale === 'en' && this.work.name.length > 50) {
					return 'Введите до 50 символов '
				}
				if (this.$i18n.locale === 'zh' && this.work.name.length > 40) {
					return '姓名最多输入40个字符'
				}
			}
			if (!this.work.age) {
				return '请填写基本信息'
			}
			if (!this.work.from) {
				return '请填写基本信息'
			}

			return null
		},
		uploadUserInfo(fileResult) {
			const { subphoto, id } = fileResult
			let param = new FormData() //创建form对象
			param.append('title', this.work.title)
			param.append('creator_name', this.work.name)
			param.append('creator_age', this.work.age)
			param.append('creator_from', this.work.from)
			param.append('subphoto', subphoto)
			param.append('photo_id', id)
			let config = {
				headers: { 'Content-Type': 'multipart/form-data' }
			} //添加请求头

			this.$axios
				.post('/work', param, config)
				.then((res) => {
					if (res.data.code === 200) {
						this.$message.success('上传成功')
						this.$router.push({
							name: 'PagesFinish',
							query: { name: this.work.name }
						})
					} else {
						this.$message.error(res.data.msg || '上传失败，请刷新重试')
					}
				})
				.catch(() => {
					this.$message.error('上传失败，请刷新重试')
				})
				.finally(() => {
					this.saving = false
				})
		},
		uploadWork() {
			this.saving = true
			let param = new FormData() //创建form对象
			param.append('filename', this.work.file) //通过append向form对象添加数据
			let config = {
				headers: { 'Content-Type': 'multipart/form-data' }
			} //添加请求头

			this.$axios
				.post('/image/upload', param, config)
				.then((res) => {
					if (res.data.code === 200) {
						this.fileResult = res.data.data
						this.$message.success(res.data.msg)
					} else {
						this.saving = false
						this.$message.error(res.data.msg || '上传失败，请刷新重试')
					}
				})
				.catch(() => {
					this.saving = false
					this.$message.error('上传失败，请刷新重试')
				})
		},
		save() {
			const error = this.validate()
			if (error) {
				this.$message({
					message: error,
					customClass: 'validate-error',
					type: 'error'
				})
			} else {
				this.uploadUserInfo(this.fileResult)
			}
		},
		uploadFile() {
			this.$refs.filePicker.click()
		},
		onFilePicked(evt) {
			this.work.file = evt.target.files[0]
			this.uploadWork()
		},
		fileUrl(file) {
			if (!file) {
				return ''
			}
			return window.URL.createObjectURL(file)
		}
	},
	mounted() {
		if (localStorage.getItem('lang')) {
			this.$i18n.locale = localStorage.getItem('lang')
		}
	}
}
</script>

<style lang="stylus">
.pages-upload {
  height: 100vh;
  width: 100vw;
  margin: 0 auto;
  padding: 40px 0;
  background: url('../assets/comment/upload-bg.png') no-repeat;
  background-size: cover;

  .hidden {
    display: none !important;
  }

  .upload-wrapper {
    position: relative;
    box-sizing: border-box;
    width: 70%;
    margin: 0 auto;
    background-color: rgba(171, 173, 226, 0.6);
    border-radius: 20px;
    padding: 30px;

    .close {
      display: none;
    }

    .back {
      position: absolute;
      top: 40px;
      right: 30px;
      cursor: pointer;

      img {
        width: 40px;
        height: 25px;
      }
    }

    .title-img {
      width: 260px;
      height: 80px;
      margin-bottom: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .upload-file-wrapper {
    margin-top: 10px;

    .upload-left {
      position: relative;
      height: 360px;
      background-color: #fff;

      .left-top {
        position: absolute;
        left: -15px;
        top: -15px;
        z-index: 999;
        width: 60px;
        height: 60px;
      }

      .right-bottom {
        position: absolute;
        right: -20px;
        bottom: -20px;
        z-index: 999;
        width: 100px;
        height: 100px;
      }

      .upload-img {
        position: absolute;
        left: 12px;
        right: 12px;
        top: 12px;
        bottom: 12px;
        border: 4px solid #aabefc;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .label {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        span {
          color: #9cacfc;
        }

        .upload-label {
          font-size: 20px;
          margin-bottom: 8px;
          font-weight: bold;
        }

        .upload-msg {
          font-size: 10px;
        }
      }
    }

    img {
      width: 450px;
      height: 260px;
      object-fit: contain;
    }
  }

  .save-btn {
    margin-top: 20px;
    text-align: center;
    cursor: pointer;

    img {
      height: 40px;
      object-fit: contain;
    }
  }

  .work-form {
    margin-top: 40px;
    text-align: center;

    .logo {
      width: 150px;
      height: 150px;
      line-height: 150px;
      font-weight: 500;
      font-size: 20px;
      margin: 0 auto;
      border: 1px solid #eee;
    }

    .form-title {
      font-size: 14px;
      font-weight: 500;
      margin: 12px 0;
      color: #fff;
    }

    .filed-label {
      margin: 8px 0;
      color: #fff;
      font-weight: 500;
    }

    .filed-input {
      .msg {
        color: #fff;
        font-size: 10px;
      }

      .el-input {
        width: 200px;
      }

      .el-input__inner {
        background-color: transparent;
        border: 2px solid #fff;
        border-radius: 4px;
        color: #fff;
        font-weight: 500;
      }
    }
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .pages-upload {
    background: url('../assets/mobileImagesBg/m-upload-bg.png') no-repeat;
    background-size: cover;
  }

  .validate-error {
    min-width: 60%;
    width: 60%;
    top: 30px !important;
  }

  .upload-wrapper {
    width: 90% !important;
    padding: 12px !important;

    .close {
      display: block !important;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background-color: #eb6877;
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 26px;
      font-weight: 700;
      border-radius: 10px;
    }

    .back {
      display: none;
    }

    .title-img {
      width: 100% !important;
      margin-bottom: 20px !important;
    }

    .upload-img {
      border-width: 2px !important;
    }

    .upload-left {
      height: 185px !important;

      .upload-msg {
        width: 80%;
        text-align: center;
      }

      .left-top {
        width: 45px !important;
        height: 45px !important;
        left: -10px !important;
        top: -10px !important;
      }

      .right-bottom {
        width: 55px !important;
        height: 55px !important;
        right: -10px !important;
        bottom: -10px !important;
      }
    }
  }

  .work-form {
    margin-top: 60px !important;

    .el-row {
      margin-bottom: 8px !important;
      display: flex;
      align-items: center;
    }

    .filed-input {
      text-align: left !important;

      .el-input {
        width: 200px !important;
      }
    }
  }

  .upload-file-wrapper {
    margin-top: 20px;
    height: 150px !important;
  }

  .upload-file-wrapper {
    .label {
      font-size: 12px !important;
      word-break: break-all;
    }

    .upload-label {
      font-size: 14px !important;
    }
  }

  .save-btn {
    text-align: center !important;
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
}

/* 平板 */
@media screen and (min-width: 600px) and (max-width: 960px) {
  .upload-file-wrapper {
    margin-top: 20px;
    height: 500px !important;
  }

  .filed-input {
    input {
      height: 35px;
      line-height: 35px;
    }
  }

  .save-btn {
    margin-top: 20px !important;
  }
}
</style>
